import Offtake_Comparision from "./OfftakeComparison";
import RealizationComparision from "./RealizationComparison";
import RetailComparision from "./RetailComparison";
import MsVahanTiv2 from "./VahaanTiv2";
const MomComparision = () => {
  return (
    <section className="p-2 px-0 md:w-full space-y-2">
      {/* Row 1 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
        <Offtake_Comparision />
        <RetailComparision />
      </div>

      {/* Row 2 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
        <RealizationComparision />
        <MsVahanTiv2 />
      </div>
    </section>
  );
};

export default MomComparision;
